import deRoutes from './environment/production/traum-ferienwohnungen.de.json'
import { Routes } from './types'

export const defaultRoutes = deRoutes as Routes
